import { Events } from 'src/constants/webSocketConsts/events';
import {
  removeMessageSettingsAction,
  setMessageSettingsAction,
} from 'src/store/settings/actions';
import { ensureUnreachable } from 'src/utils/common_utils';

export const MessageSettingsHandler = (event: Events, items: Array<any>) => {
  switch (event) {
    case Events.Insert:
    case Events.Modify:
      return setMessageSettingsAction(items);
    case Events.Remove:
      return removeMessageSettingsAction(items);
    case Events.DomainVerified:
    case Events.Refresh:
      return null;
    default:
      return ensureUnreachable(event);
  }
};
